import React, { Component } from 'react'
import './VerticalGroupBar.scss'

export default class VerticalGroupBar extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
             activeTabSection : [],
             currentSection : ""
        }
    }
    
    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if (this.props !== prevProps) {
            this.setState({
                activeTabSection : this.props.activeTabSection,
                currentSection : this.props.currentSection
            })
       }}

    handleClick(e,sectionId){
        this.setState({ 
            currentSection : sectionId
        }) 
        const ID = "#v" + sectionId
        const anchor = document.querySelector(ID)
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' })
        this.props.updateState(sectionId)
    }
    render() {
        return (
            <div className="tab-tools-groupbar">
            <div className="is-size-h6 bold pl-5 pt-6">Available Sections</div>
            <ul>
            { this.props.activeTabSection.map((grpname)=>
                <div className="tab-tools-group">
                <li key={grpname.sectionId} className={this.state.currentSection === grpname.sectionId ? "active-grp" : " "} 
                onClick={(e)=>this.handleClick(e,grpname.sectionId)}>
                { grpname.sectionTitle ? grpname.sectionTitle
                : "New Section" }
                </li>
                </div>
            )}
            </ul>           
          </div>
        )
    }
}
